import availableHooks from './constants/available-hooks';
import extensionHooks from './constants/extension-hooks';
import middleware from './middleware';
import operations from './operations';
import handlers from './handlers';

export default {
  availableHooks,
  extensionHooks,
  middleware,
  operations,
  handlers,
};
